const DELETE_ALLOWED_ROLES = new Set([
  'admin',
  'sales manager',
  'procurement manager',
]);

const PRIVATE_SUPPLIER_ALLOWED_ROLES = new Set([
  'admin',
  'procurement manager',
  'procurement user',
]);

const SUPPLIER_VISIBILITY_MANAGEMENT_ROLES = new Set([
  'admin',
  'procurement manager',
  'procurement user',
]);

const PRODUCT_MANAGEMENT_ROLES = new Set([
  'admin',
  'procurement manager',
  'procurement user',
]);

export const canDeleteRecords = (user) => DELETE_ALLOWED_ROLES.has(user?.role);

export const canViewPrivateSuppliers = (user) => PRIVATE_SUPPLIER_ALLOWED_ROLES.has(user?.role);

export const canManageSupplierVisibility = (user) => SUPPLIER_VISIBILITY_MANAGEMENT_ROLES.has(user?.role);

export const canManageProducts = (user) => PRODUCT_MANAGEMENT_ROLES.has(user?.role);

export const canViewSuppliersInCounterpartyList = (user) => (
  user?.role === 'admin' || String(user?.role || '').includes('procurement')
);

export const filterVisibleSuppliers = (suppliers, user) => {
  if (canViewPrivateSuppliers(user)) return suppliers;
  return suppliers.filter((supplier) => (supplier.visibility || 'Public') !== 'Private');
};

export const filterVisibleSupplierProducts = (supplierProducts, visibleSuppliers) => {
  const visibleSupplierIds = new Set(visibleSuppliers.map((supplier) => supplier.id));
  return supplierProducts.filter((supplierProduct) => visibleSupplierIds.has(supplierProduct.supplierId));
};
